import { Container, Row, Col } from "react-bootstrap";
import FichaSolicitante from "../../components/funcionarios/FichaSolicitante";

function FichaAtendiendo({fallback}) {
  return (

          <FichaSolicitante isAtendiendo={true} fallback={fallback}/>

  );
}

export default FichaAtendiendo;
